<div class="row" id="Mydivdrag">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnLoadList" (click)="getJournals()" style="display:none">Get</button>
        <button type="button" (click)="show()" id="btn_AddNew" style="display:none">Add</button>
        <button type="button" id="btnImportData" (click)="importExcelPopup()" style="display:none">Excel</button>
        <div class="row" id="FilterJournal" style="display:none">
          <div class="col-sm-2">
            <div class="form-group">
              Journal Mode
              <select class="form-control" id="Filterjournalmode">
                <option selected value="ALL">ALL</option>
                <option value="PM">PM</option>
                <option value="NonPM">NonPM</option>
              </select>
            </div>
          </div>
          <div class="col-sm-2">
            <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="getJournals()">Search</button>
            <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
          </div>
        </div>

        <div id="journalsTable" class="divContainer" style="top:1px;">
          <table #dataTable class="display" style="width:100%"></table>
        </div>
        <div id="journalsForm" class="content main-body" style="display: none;">
          <!--popup body-->
          <div style="overflow:hidden !important" id="popupbody">
            <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
              <li class="nav-item"><a data-toggle="tab" href="#divJournals" class="nav-link active">Journal Info</a></li>
              <li class="nav-item" id="generalinfotab"><a data-toggle="tab" href="#divOthers" class="nav-link">General Info</a></li>
              <li class="nav-item" id="contactinfotab"><a data-toggle="tab" href="#divContact" class="nav-link">Contact Info</a></li>
              <li class="nav-item" id="journalnotestab"><a data-toggle="tab" href="#divNotes" class="nav-link">Notes</a></li>
              <li class="nav-item" id="journalotherstab"><a data-toggle="tab" href="#divJournalOthers" class="nav-link">Others</a></li>
              <li class="nav-item" id="onshoreInfotab"><a data-toggle="tab" href="#divJournalOnshoreInfo" class="nav-link">Onshore Info</a></li>
              <li class="nav-item" id="deliverydetailstab"><a data-toggle="tab" href="#divDelivery" class="nav-link">Delivery Details</a></li>
              <li class="nav-item" id="budgettab"><a data-toggle="tab" href="#divBudget" class="nav-link">Budget</a></li>
            </ul>
            <br />
            <div class="tab-content" id="journalstabContent" style="min-height:300px">
              <!--Journal Info tab-->
              <div class="tab-pane active" id="divJournals" style="overflow-x:hidden; overflow-y:auto !important;">
                <div class="row">
                  <div class="col-sm-3" id="JournalAcronym">
                    <div class="form-group">
                      <label for="txtAcronym ">Acronym<em>*</em></label>
                      <input type="text" class="form-control" id="txtAcronym" (change)="onSearchChange($event)" autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-sm-9" id="JournalTitle">
                    <div class="form-group">
                      <label for="txtTitle ">Title<em>*</em></label>
                      <input type="text" class="form-control" id="txtTitle" (change)="onSearchChange($event)" autocomplete="off">
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-sm-3" id="ddlJournalPublisher">
                    <div class="form-group">
                      <label for="ddlPublisherID ">Publisher<em>*</em></label>
                      <select id="ddlPublisherID" class="form-control">
                        <option *ngFor="let item of publisherID" value={{item.ID}}>
                          {{item.PublisherName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm" id="JournalDOICode">
                    <div class="form-group">
                      <label for="txtDoiJournalCode ">DOI Journal Code<em>*</em></label>
                      <input type="text" class="form-control" id="txtDoiJournalCode" autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-sm" id="JournalPublisher">
                    <div class="form-group">
                      <label for="txtJournalPublisher ">Journal Publisher<em>*</em></label>
                      <input type="text" class="form-control" id="txtJournalPublisher" autocomplete="off" />
                    </div>
                  </div>
                  <!--new -->
                  <div class="col-sm" id="JournalAbbrevJournalTitle">
                    <div class="form-group">
                      <label for="txtAbbrevJournalTitle ">Abbrev Journal Title<em>*</em></label>
                      <input type="text" class="form-control" id="txtAbbrevJournalTitle" autocomplete="off" />
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-sm-3" id="JournalType">
                    <div class="form-group">
                      <label for="ddlJournalType ">Journal Type<em>*</em></label>
                      <select id="ddlJournalType" class="form-control">
                        <option *ngFor="let item of journalType" value={{item.SNo}}>
                          {{item.TypeName}}
                        </option>
                      </select>
                    </div>
                  </div>



                  <div class="col-sm" id="JournalTAT">
                    <div class="form-group">
                      <label for="txtTAT ">TAT<em>*</em></label>
                      <input type="number" class="form-control" id="txtTAT" min="0" autocomplete="off" />
                    </div>
                  </div>

                  <div class="col-sm" id="JournalIssuebudgetedpages">
                    <div class="form-group">
                      <label for="txtIssuebudgetedpages ">Issue Budgeted Pages</label>
                      <input type="number" class="form-control" id="txtIssuebudgetedpages" min="0" autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-sm" id="JournalFolderName">
                    <div class="form-group">
                      <label for="txtjournalFolderName ">Journal Folder Name<em>*</em></label>
                      <input type="text" class="form-control" id="txtjournalFolderName" autocomplete="off" />
                    </div>
                  </div>
                </div>

                <!--new end -->

                <div class="row">
                  <div class="col-sm-2">
                    <div class="form-group">

                      <label for="txtjournalFolderName ">Status<em>*</em></label>
                      <br />
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="status" value="1" id="rdActivate">
                        <label class="form-check-label" for="rdActivate">Activate</label>
                        <input class="form-check-input" type="radio" name="status" value="0" id="rdDeactivate" style="left:40%">
                        <label class="form-check-label label-padding" for="rdDeactivate" style="padding-left:14%">Deactivate</label>
                      </div>
                      <!--<div class="form-check">

                      </div>-->
                    </div>
                  </div>
                  <div class="col-sm-2 clsMargin">
                    <div class="form-group">
                      <input type="checkbox" id="chkManuflow">&nbsp;
                      <label>Manuflow</label>
                    </div>
                  </div>


                  <div class="col-sm-2" id="JournalMode">
                    <div class="form-group">
                      <label for="journalmode ">Journal Mode</label>
                      <select class="form-control" id="journalmode">
                        <option value="PM">PM</option>
                        <option value="NonPM">NonPM</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-2" id="JournalPlatform">
                    <label for="lstPlatform ">Platform</label>
                    <select class="form-control" id="lstPlatform">
                      <option *ngFor="let item of platformList" value={{item.SNo}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-2" id="JournalStartingVolumeIssueYear">
                    <div class="form-group">
                      <label for="txtStartingYear"> Starting Volume/Issue Year<em>*</em></label>
                      <input type="number" class="form-control" id="txtStartingYear" />
                    </div>
                  </div>

                  <div class="col-sm-2" id="JournalStartingVolume">
                    <div class="form-group">
                      <label for="txtStartingVolume">Starting Volume<em>*</em></label>
                      <input type="number" class="form-control" id="txtStartingVolume" />
                    </div>
                  </div>
                  <div class="col-sm-2" id="JournalStartingIssue">
                    <div class="form-group">
                      <label for="txtStartIssueNo">Starting Issue<em>*</em></label>
                      <input type="number" class="form-control" id="txtStartIssueNo" />
                    </div>
                  </div>
                  <div class="col-sm-2" id="JournalEndingIssue">
                    <div class="form-group">
                      <label for="txtEndIssueNo">Ending Issue<em>*</em></label>
                      <input type="number" class="form-control" id="txtEndIssueNo" />
                    </div>
                  </div>

                  <div class="col-sm-2" id="JournalISSNPrint">
                    <label for="txtISSNPrint "> ISSN Print</label>
                    <input type="text" class="form-control" id="txtISSNPrint" autocomplete="off">
                  </div>
                  <div class="col-sm-2" id="JournalISSNWeb">
                    <label for="txtISSNWeb ">ISSN Web</label>
                    <input type="text" class="form-control" id="txtISSNWeb" autocomplete="off">
                  </div>
                  <div class="col-sm-2" id="JournalOnline">
                    <label for="txtOnline "> Online</label>
                    <input type="text" class="form-control" id="txtOnline" autocomplete="off" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm" id="JournalArticleType">
                    <div class="form-group">
                      <label for="ddlArticleTypeList ">Article Type<em>*</em></label>
                      <select id="ddlArticleTypeList" class="form-control" multiple>
                        <option *ngFor="let item of ArticleTypeList" value={{item.SNo}}>
                          {{item.TypeName}}
                        </option>
                      </select>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12" id="JournalAllocatedUsers">
                    <div class="form-group">
                      <label for="ddlAllocatedUsers ">Allocated Users</label>
                      <select id="ddlAllocatedUsers" class="form-control" multiple>
                        <option *ngFor="let item of AllocatedUsers" value={{item.UserID}}>
                          {{item.LoginID}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!--General Info tab-->
              <div class="tab-pane" id="divOthers" style="overflow-x:hidden; overflow-y:auto !important;">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalContact">
                      <label for="txtJrlContact ">Journal Contact<span class="required">*</span></label>
                      <input type="text" class="form-control" id="txtJrlContact" autocomplete="off" />
                    </div>
                    <div class="col-sm" id="JournalEmail">
                      <label for="txtEmailId ">Journal Email<span class="required">*</span></label>
                      <input type="text" class="form-control" id="txtEmailId" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalProductionEditor">
                      <label for="txtProductionEditor ">Production Editor</label>
                      <input type="text" class="form-control" id="txtProductionEditor" autocomplete="off" />
                    </div>
                    <div class="col-sm" id="JournalProductionEditorEmail">
                      <label for="txtProductionEditorEmail "> Production Editor Email</label>
                      <input type="text" class="form-control" id="txtProductionEditorEmail" autocomplete="off" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalProjectManager">
                      <label for="txtProjectManager ">Project Manager</label>
                      <input type="text" class="form-control" id="txtProjectManager" autocomplete="off" />
                    </div>
                    <div class="col-sm" id="JournalProjectManagerEmail">
                      <label for="txtProjectManageremail "> Project Manager Email <span class="required">*</span></label>
                      <input type="text" class="form-control" id="txtProjectManageremail" autocomplete="off" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalProductionEmail">
                      <label for="txtProductionEmail ">  Production Email<span class="required">*</span></label>
                      <input type="text" class="form-control" id="txtProductionEmail" (change)="MultipleEmail($event)" />
                    </div>
                    <div class="col-sm" id="JournalProductionManager">
                      <label for="txtProductionManager "> Production Manager<span class="required">*</span></label>
                      <input type="text" class="form-control" id="txtProductionManager" autocomplete="off" />
                    </div>
                    <div class="col-sm" id="JournalProductionManagerEmail">
                      <label for="txtProductionManagerEmail "> Production Manager Email<span class="required">*</span></label>
                      <input type="text" class="form-control" id="txtProductionManagerEmail" autocomplete="off" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalProofingCCEmail">
                      <label for="txtProofingCCEmail ">ProofingCC Email</label>
                      <input type="text" class="form-control" id="txtProofingCCEmail" autocomplete="off" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalApprovalccEmail">
                      <label for="txtApprovalccEmail ">Approval CC Email</label>
                      <input type="text" class="form-control" id="txtApprovalccEmail" autocomplete="off" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalDefectNotifyEmail">
                      <label for="txtdefectnotifyemail ">Defect Notify Email</label>
                      <input type="text" class="form-control" id="txtdefectnotifyemail" autocomplete="off" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalGroupEmail">
                      <label for="txtGroupEmailId "> Group Email</label>
                      <input type="text" class="form-control" id="txtGroupEmailId" autocomplete="off" (change)="MultipleEmail($event)" />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-2" id="JournalProofingFlow">
                      <div class="form-group">
                        <label for="ddlProofingType ">Proofing Flow<em>*</em></label>
                        <select id="ddlProofingType" class="form-control">
                          <option *ngFor="let item of proofingType" value={{item.ProofingType}}>
                            {{item.ProofingType}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm" id="JournalWebAddress">
                      <label for="txtWebAddress "> WebAddress</label>
                      <input type="text" class="form-control" id="txtWebAddress" autocomplete="off" />
                    </div>
                    <div class="col-sm" id="JournalWebLink">
                      <label for="txtWebLink "> WebLink</label>
                      <input type="text" class="form-control" id="txtWebLink" autocomplete="off" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm" id="JournalCopyright">
                      <label for="txtcopyright ">Copyright</label>
                      <textarea type="text" class="form-control" id="txtcopyright"> </textarea>
                    </div>
                  </div>
                </div>
              </div>

              <!--Contact Info tab-->
              <div class="tab-pane" id="divContact">
                <div class="row">
                  <div class="col">
                    <span id="spAddContact" class="btn btn-outline-info waves-effect waves-light Addbtn" (click)="showContact()"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                  </div>
                </div>
                <button type="button" id="btnDeleteContact" (click)="deleteContact()" style="display:none">Delete Contact</button>
                <button type="button" id="spUpdateContact" class=" above" (click)="updateContactData()" style="display:none"></button>

                <div class="col-md-12">
                  <div class="form-group tblRightsList fixTableHead" id="divAddContactList">
                    <table id="tblAddContactList" class="table" style="overflow-y: scroll !important; ">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Role</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Address</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>

                <div class="modal" id="myModal" [style.display]="showContactModal ? 'block' : 'none'">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header" id="modal-headerid">
                        <h4 class="modal-title">Contact Info</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="hideContact()">&times;</button>
                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-sm-6" name="JournalWebLink">
                            <div class="form-group">
                              <label for="lstRoles "> Role<em>*</em></label>
                              <select id="lstRoles" class="form-control">
                                <option *ngFor="let item of roleList" value={{item.Id}}>
                                  {{item.RoleName}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6" name="JournalName">
                            <div class="form-group">
                              <label for="txtContact ">Name<em>*</em></label>
                              <input type="text" class="form-control" id="txtContact">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12" name="JournalContactEmail">
                            <div class="form-group">
                              <label for="txtEmail "> Email<em>*</em></label>
                              <input type="email" class="form-control" id="txtEmail" (change)="MultipleEmail($event)">
                            </div>
                          </div>
                          <div class="col-sm-12" name="JournalAddress">
                            <div class="form-group">
                              <label for="txtAddress "> Address</label>
                              <textarea class="form-control" id="txtAddress" autocomplete="off" rows="2"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideContact()">Close</button>
                        <button type="submit" (click)="addUpdateContact()" class="btn btn-outline-success waves-effect waves-light">{{contactModalButton}}</button>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Notes Info tab-->
              <div class="tab-pane" id="divNotes">
                <div class="row">
                  <div class="col-6" id="notesJournal">
                    <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
                      <li class="nav-item"><a data-toggle="tab" href="#divJrlNotes" name="upload" class="nav-link active">Journal Notes</a></li>
                      <li class="nav-item"><a data-toggle="tab" href="#divGeneralNotes" name="main" class="nav-link">General Notes</a></li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="divJrlNotes">
                        <form role="form">
                          <div class="col-lg" id="JournalTopBanner">
                            <div class="form-group">
                              <textarea type="text" class="form-control" id="txtTopBanner" rows="7" autocomplete="off"> </textarea>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="tab-pane" id="divGeneralNotes">
                        <form role="form">
                          <div class="col-lg" id="JournalGeneralNotes">
                            <div class="form-group">
                              <textarea type="text" class="form-control" id="txtGeneralNotes" rows="7" autocomplete="off"> </textarea>
                            </div>
                          </div>
                        </form>
                      </div>

                    </div>

                  </div>

                  <div class="col-6">
                    <div class="col-12">
                      <span id="spAddJournalNotes" class="btn btn-outline-info waves-effect waves-light Addbtn" (click)="showJournalNotes()"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                    </div>
                    <button type="button" id="btnDeleteJournalNotes" (click)="Deleteconfirmation()" style="display:none">Delete JournalNotes</button>
                    <button type="button" id="btnDeleteJournalNote" (click)="deleteJournalNotes()" style="display:none">Delete JournalNotes</button>
                    <button type="button" id="btnDwnldjNotes" (click)="DownloadJournalNotes()" style="display:none">Download JournalNotes</button>

                    <div class="form-group col-12 tblRightsList fixTableHead" id="divStageNotesList">
                      <table id="tblAddJournalNotes" class="table" Style="width:100%">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>File Type</th>
                            <th>Description</th>
                            <th>Upload File</th>
                            <th style='text-align: center'>Actions</th>
                          </tr>
                        </thead>
                        <tbody></tbody>
                      </table>
                    </div>

                    <div class="modal" id="myModalnotes" [style.display]="showNotesModal ? 'block' : 'none'">
                      <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h4 class="modal-title">{{title}}</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="hideNotes()">&times;</button>
                          </div>
                          <div class="modal-body">
                            <div class="form-group">
                              <div class="col-12">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <label for="ddlJournalNote">Type</label>
                                    <select id="ddlJournalNotes" class="form-control">
                                      <option *ngFor="let item of journalFileTypeList" value={{item.FileTypeName}}>
                                        {{item.FileTypeName}}
                                      </option>
                                    </select>
                                  </div>&nbsp;
                                  <div class="col-sm-12" id="JNotesDescription">
                                    <label for="JNotesDescription ">Description</label>
                                    <textarea type="text" class="form-control" rows="10" id="JournalNotesDescription"> </textarea>
                                  </div>&nbsp;
                                </div>
                                <div class="row">
                                  <div class="col-sm-4">
                                    <div class="UploadFile">
                                      <input #fileInput type="file" (change)="onuploadSelected($event)" id="doc_uploadfile" />
                                      <em>['doc', 'docx', 'pdf', 'zip','xlsx','xls']</em>
                                    </div>
                                  </div>
                                  <div class="col-sm-8">
                                    <div id="btndownloadJournalNotes">
                                      <button class="btn" id="btndownloadJnotes" style="color:#556ee6" (click)="DownloadJournalNotes()"><i class="fa fa-download"></i> {{FileName}}</button>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideNotes()">Close</button>
                            <button type="submit" (click)="addUpdateNotes()" class="btn btn-outline-success waves-effect waves-light">{{NotesModalButton}}</button>
                          </div>

                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
              <!--<div id="LoadingImagenotes" style="display:none">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>-->
              <!--Others Info tab-->
              <div class="tab-pane" id="divJournalOthers" style="overflow-x:hidden; overflow-y:auto !important;">
                <!--Others tab-->
                <div class="row">
                  <div class="col-sm" id="JournalCode">
                    <div class="form-group">
                      <label for="txtJournalCode ">Journal Code<em>*</em></label>
                      <input type="text" class="form-control" id="txtJournalCode" autocomplete="off" />
                    </div>
                  </div>

                  <div class="col-sm" id="JournalMedia">
                    <div class="form-group">
                      <label for="txtJournalMedia">Media<em>*</em></label>
                      <input type="text" class="form-control" id="txtJournalMedia" autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-sm" id="JournalIssuesPerYear">
                    <div class="form-group">
                      <label for="txtIssuesPerYear">Issues Per Year<em>*</em></label>
                      <input type="number" class="form-control" id="txtIssuesPerYear" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm" id="JournalPrintPublisherID">
                    <label for="txtPrintPublisherID">Print Publisher</label>
                    <select class="form-control" id="txtPrintPublisherID">
                      <option *ngFor="let item of PrintPublisherList" value={{item.ID}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalCorrXMLID">
                    <label for="txtCorrXMLID">CorrectionXML</label>
                    <select class="form-control" id="txtCorrXMLID">
                      <option *ngFor="let item of CorrXMLIDList" value={{item.ID}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalPreApprovalID">
                    <label for="txtPreApprovalID">PreApproval</label>
                    <select class="form-control" id="txtPreApprovalID">
                      <option *ngFor="let item of PreApprovalList" value={{item.ID}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalPageLayoutID">
                    <label for="txtPageLayoutID">PageLayout</label>
                    <select class="form-control" id="txtPageLayoutID">
                      <option *ngFor="let item of PageLayoutList" value={{item.SNo}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalStyleID">
                    <label for="StyleId">Style</label>
                    <select class="form-control" id="StyleId">
                      <option *ngFor="let item of styleList" value={{item.SNo}}>
                        {{item.StyleName}}
                      </option>
                    </select>
                  </div>
                </div><br />
                <br />

                <div class="row">
                  <div class="col-sm" id="JournalCEID">
                    <label for="txtCEID">CE</label>
                    <select class="form-control" id="txtCEID">
                      <option *ngFor="let item of CEIDList" value={{item.ID}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalBillingID">
                    <label for="txtBillingID">Billing</label>
                    <select class="form-control" id="txtBillingID">
                      <option *ngFor="let item of BillingList" value={{item.SNo}}>
                        {{item.TypeName}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalProjectFromID">
                    <label for="txtProjectFromID">Project From</label>
                    <select class="form-control" id="txtProjectFromID">
                      <option *ngFor="let item of ProjectFromList" value={{item.ID}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalFileLocationID">
                    <label for="txtFileLocationID">File Location</label>
                    <select class="form-control" id="txtFileLocationID">
                      <option *ngFor="let item of FileLocationList" value={{item.ID}}>
                        {{item.Location}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm" id="JournalPrinterID">
                    <label for="txtPrinterID">Printer</label>
                    <select class="form-control" id="txtPrinterID">
                      <option *ngFor="let item of PrinterList" value={{item.ID}}>
                        {{item.Name}}
                      </option>
                    </select>
                  </div>
                </div><br /><br />

                <div class="row">
                  <div class="col-sm-12" id="JournalStagesList">
                    <div class="form-group">
                      <label for="ddlStagesList ">Stages</label>
                      <select id="ddlStagesList" class="form-control" multiple>
                        <option *ngFor="let item of Stages" value={{item.ID}}>
                          {{item.StageName}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <label for="JournalLogo">Logo</label>
                    <div class="input-group" style="text-align:center;">
                      <img src="../../../assets/Images/userLogo.jpg" alt="Profile" style="height:110px;width:110px;margin-top:10px;border-radius:10px;" id="imgProfile" (error)="onerrorImageLoad()" /> <br /><br />
                      <input type="file" name="file" id="imageUploadForm" style="width: 100%;margin-left:10px" class="btn" (change)="showPreview($event)" />
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="col-sm-4" style=" margin-left: 70%; display: grid;">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group">
                            <input type="checkbox" id="chkIsAuthorChase">&nbsp;
                            <label>IsAuthor Chase</label>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <input type="checkbox" id="chkIsUploadBlock">&nbsp;
                            <label>IsUpload Block</label>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <input type="checkbox" id="chkProofingEGAPICall">&nbsp;
                            <label>Proofing EG APICall</label>
                          </div>
                        </div>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <input type="checkbox" id="chkSPM">&nbsp;
                            <label>SPM</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Allocated User Info tab-->
              <div class="tab-pane" id="divJournalOnshoreInfo">

                <button type="button" id="btnDeleteOnshore" (click)="DeleteOnshoreconfirmation()" style="display:none">Delete JournalNotes</button>
                <button type="button" id="btnDeleteJournalOnshore" (click)="deleteJournalOnshore()" style="display:none">Delete JournalNotes</button>
                <div class="row">
                  <div class="col-12">
                    <span id="spAddOnshore" class="btn btn-outline-info waves-effect waves-light Addbtn" (click)="showJournalOnshore()"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                  </div>
                  <div class="form-group col-12 tblRightsList fixTableHead">
                    <table id="tblAddOnshore" class="table" Style="width:100%">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Task</th>
                          <th>TAT</th>
                          <th>Allocation Type</th>
                          <th>Code</th>
                          <th>OA Code</th>
                          <th style='text-align: center'>Actions</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>


                </div>
                <div class="modal" id="myModalOnshore" [style.display]="showOnshoreModal ? 'block' : 'none'">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title">{{title}}</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="hideOnshore()">&times;</button>
                      </div>
                      <div class="modal-body">
                        <div class="form-group">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-sm-12" name="Task">

                                <label for="ddlVendorTask ">Task<em>*</em></label>
                                <select id="ddlVendorTask" class="form-control">
                                  <option *ngFor="let item of journalVendorTaskList" value={{item.ID}}>
                                    {{item.TaskName}}
                                  </option>
                                </select>

                              </div>
                            </div>
                            <br />
                            <div class="row">
                              <div class="col-sm-3">
                                <label for="txtOnshoreTAT">TAT</label>
                                <input type="number" class="form-control" id="txtOnshoreTAT" />
                              </div>
                              <div class="col-sm-3">
                                <label for="ddlAllocationType ">Allocation Type</label>&
                                <select class="form-control" id="ddlAllocationType">
                                  <option value="Auto" selected="selected">Auto</option>
                                  <option value="Manual">Manual</option>

                                </select>
                              </div>
                              <div class="col-sm-3">
                                <label for="txtOnshoreCode">Code</label>&nbsp;
                                <input type="text" class="form-control" id="txtOnshoreCode" />
                              </div>
                              <div class="col-sm-3">
                                <label for="txtOnshoreOACode">OA Code</label>&nbsp;
                                <input type="text" class="form-control" id="txtOnshoreOACode" />
                              </div>&nbsp;
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideOnshore()">Close</button>
                        <button type="submit" (click)="addOnshoreTask()" class="btn btn-outline-success waves-effect waves-light">{{NotesModalButton}}</button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <!--Delivery Info tab-->
              <div class="tab-pane" id="divDelivery">
                <div class="row">
                  <div class="col">
                    <span id="spAddDelivery" class="btn btn-outline-info waves-effect waves-light Addbtn" (click)="showDelivery()"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                  </div>
                </div>
                <button type="button" id="spUpdateDelivery" class="deliveryAddbtn" (click)="updateDeliveryData()" style="display:none"></button>
                <button type="button" id="btnDeleteDelivery" (click)="deleteDelivery()" style="display:none">Delete Delivery</button>
                <button type="button" id="btnGetDeliveryMethod" (click)="getDeliveryMethods()" style="display:none">GetDeliveryMethods</button>
                <div class="form-group tblRightsList fixTableHead">
                  <table id="tblAddDeliveryList" class="table" width="100%">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Delivery Type</th>
                        <th>Collect File Location</th>
                        <th>File Format</th>
                        <th>Delivery Method</th>
                        <!--S3-->
                        <th style="display:none">Bucket Name</th>
                        <th style="display:none">Access Key</th>
                        <th style="display:none">Security Key</th>
                        <th style="display:none">EndPointRegion</th>
                        <th style="display:none">Remarks</th>
                        <!--FTP-->
                        <th style="display:none">Host</th>
                        <th style="display:none">UserName</th>
                        <th style="display:none">Password</th>
                        <th style="display:none">Port</th>
                        <th style="display:none">Remarks</th>
                        <!--SFTP-->
                        <th style="display:none">Host</th>
                        <th style="display:none">UserName</th>
                        <th style="display:none">Password</th>
                        <th style="display:none">Port</th>
                        <th style="display:none">Folder Path</th>
                        <th style="display:none">Remarks</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>

                <div class="modal " id="myModal" [style.display]="showDeliveryModal ? 'block' : 'none'">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title">Delivery Details</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="hideDelivery()">&times;</button>
                      </div>
                      <div class="modal-body" style="overflow-x:scroll">
                        <!--<div id="LoadingImagePopup">
                          <img src="../../assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                        </div>-->

                        <div class="row">
                          <div class="col-sm-6" name="JournalDeliveryName">
                            <div class="form-group">
                              <label for="lstDeliveries ">Name<em>*</em></label>
                              <select id="lstDeliveries" class="form-control" onchange="$('#btnGetDeliveryMethod').trigger('click');">
                                <option *ngFor="let item of deliveryList" value={{item.DeliveryName}}>
                                  {{item.DeliveryName}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6" name="JournalDeliveryType">
                            <div class="form-group">
                              <label for="ddlDeliveryMethod ">Type<em>*</em></label>
                              <select class="form-control" id="ddlDeliveryMethod">
                                <option *ngFor="let item of deliveryMethodList" value={{item.DeliveryMethod}}>
                                  {{item.DeliveryMethod}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6" name="JournalFileLocation">
                            <div class="form-group">
                              <label for="ddlFileLocation "> File Location<em>*</em></label>
                              <select class="form-control" id="ddlFileLocation" (change)="updateUi()">
                                <option value="S3" selected="selected">S3</option>
                                <option value="FTP">FTP</option>
                                <option value="SFTP">SFTP</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-3" name="JournalCollectFileLocation">
                            <div class="form-group">
                              <label for="txtFileLocation "> Collect File Location</label>
                              <input type="text" class="form-control" id="txtFileLocation" />
                            </div>
                          </div>
                          <div class="col-sm-3" name="JournalFileFormat">
                            <div class="form-group">
                              <label for="txtFileFormat "> File Format</label>
                              <input type="text" class="form-control" id="txtFileFormat" />
                            </div>
                          </div>
                        </div>

                        <div id="DS3">
                          <div class="row">
                            <div class="col-sm-4" name="JournalBucketName">
                              <div class="form-group">
                                <label for="txtBucketName "> Bucket Name<em>*</em></label>
                                <input class="form-control" type="text" id="txtBucketName">
                              </div>
                            </div>
                            <div class="col-sm-4" name="JournalAccessKey">
                              <div class="form-group">
                                <label for="txtAccessKey "> Access Key<em>*</em></label>
                                <input class="form-control" type="text" id="txtAccessKey">
                              </div>
                            </div>
                            <div class="col-sm-4" name="JournalSecurityKey">
                              <div class="form-group">
                                <label for="txtSecurityKey "> Security Key<em>*</em></label>
                                <input class="form-control" type="text" id="txtSecurityKey">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12" name="JournalEndpointRegion">
                              <div class="form-group">
                                <label for="txtEndpointregion "> Endpoint Region</label>
                                <input class="form-control" type="text" id="txtEndpointregion">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12" name="JournalRemarks">
                              <div class="form-group">
                                <label for="txtRemarks "> Remarks</label>
                                <input class="form-control" type="text" id="txtRemarks">
                              </div>
                            </div>
                          </div>
                        </div>

                        <div id="DFTP">
                          <div class="row">
                            <div class="col-sm-3" name="JournalDFTPHost">
                              <div class="form-group">
                                <label for="txtFHost "> Host<em>*</em></label>
                                <input class="form-control" type="text" id="txtFHost">
                              </div>
                            </div>
                            <div class="col-sm-3" name="JournalDFTPUserName">
                              <div class="form-group">
                                <label for="txtFUserName ">  User Name<em>*</em></label>
                                <input class="form-control" type="text" id="txtFUserName">
                              </div>
                            </div>
                            <div class="col-sm-3" name="JournalDFTPPassword">
                              <div class="form-group">
                                <label for="txtFPassword ">Password<em>*</em></label>
                                <input class="form-control" type="password" id="txtFPassword">
                              </div>
                            </div>
                            <div class="col-sm-3" name="JournalDFTPPort">
                              <div class="form-group">
                                <label for="txtFPort "> Port<em>*</em></label>
                                <input class="form-control" type="number" id="txtFPort">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12" name="JournalDFTPRemarks">
                              <div class="form-group">
                                <label for="txtFRemarks "> Remarks</label>
                                <input class="form-control" type="text" id="txtFRemarks">
                              </div>
                            </div>
                          </div>
                        </div>

                        <div id="DSFTP">
                          <div class="row">
                            <div class="col-sm-4" name="JournalDSFTPHost">
                              <div class="form-group">
                                <label for="txtSFHost "> Host<em>*</em></label>
                                <input class="form-control" type="text" id="txtSFHost">
                              </div>
                            </div>
                            <div class="col-sm-4" name="JournalDSFTPUserName">
                              <div class="form-group">
                                <label for="txtSFUserName "> User Name<em>*</em></label>
                                <input class="form-control" type="text" id="txtSFUserName">
                              </div>
                            </div>
                            <div class="col-sm-4" name="JournalDSFTPPassword">
                              <div class="form-group">
                                <label for="txtSFPassword "> Password<em>*</em></label>
                                <input class="form-control" type="password" id="txtSFPassword">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-4" name="JournalDSFTPPort">
                              <div class="form-group">
                                <label for="txtSFPort ">Port<em>*</em></label>
                                <input class="form-control" type="number" id="txtSFPort">
                              </div>
                            </div>
                            <div class="col-sm-4" name="JournalDSFTPKeyFile">
                              <div class="form-group">
                                <label for="SFfile-input"> Key File<em>*</em></label>
                                <input type="file" #file class="form-control" placeholder="Choose file" id="SFfile-input" (change)="selectUploadFile(file.files)">
                              </div>
                            </div>
                            <div class="col-sm-2" name="JournalDSFTPPort">

                              <div class="form-group">
                                <button type="button" class="btn btn-success" style="margin-top: 15px;margin-left: 10px;" (click)="submitFile()">Upload</button>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-4" name="JournalDSFTPUploadedfile">
                              <div class="form-group">
                                <label for="divDfilename ">Uploaded file</label>
                                <a id="divDfilename">
                                  <button type="button" id="btnDDownload" class="btn btn-outline-info waves-effect waves-light" (click)="downloadkeyfile()">{{ keyFilename }}</button>
                                </a>
                              </div>
                            </div>
                            <div class="col-sm-8" name="JournalSFTPFolderPath">
                              <div class="form-group">
                                <label for="txtSFFolderPath ">SFTP Folder Path</label>
                                <input class="form-control" type="text" id="txtSFFolderPath" disabled>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12" name="JournalDSFTRemarks">
                              <div class="form-group">
                                <label for="txtSFRemarks ">Remarks</label>
                                <input class="form-control" type="text" id="txtSFRemarks">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideDelivery()">Close</button>
                        <button type="submit" (click)="addUpdateDelivery()" class="btn btn-outline-success waves-effect waves-light">{{deliveryModalButton}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Budget Info tab-->
              <div class="tab-pane" id="divBudget">
                <div class="row">
                  <div class="col">
                    <span id="spAddBudget" class="btn btn-outline-info waves-effect waves-light Addbtn" (click)="showBudget()"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                  </div>
                </div>
                <button type="button" id="btnDeleteBudget" (click)="deleteBudget()" style="display:none">Delete Budget</button>

                <div class="col-md-12">
                  <div class="form-group tblRightsList fixTableHead">
                    <table id="tblAddBudgetList" class="table" style="overflow-y: scroll !important; ">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Budget Year</th>
                          <th>Budget Type</th>
                          <th>Article Budget</th>
                          <th>Projected Average Page Count</th>
                          <th>Per Issue Target</th>
                          <th>Non Research Projected total page Count</th>
                          <th>Volume Pages</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>

                <div class="modal" id="myModalbudget" [style.display]="showBudgetModal ? 'block' : 'none'">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header" id="modal-headerid">
                        <h4 class="modal-title">Budget Info</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="hideBudget()">&times;</button>
                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <!--<div class="col-sm-6" name="JournalBudgetYr">
                            <div class="form-group">
                              <label for="txtBudgetYear ">Budget Year<em>*</em></label>
                              <input type="text" class="form-control" id="txtBudgetYear">
                            </div>
                          </div>-->
                          <div class="col-sm" id="JournalBudgetYr">
                            <label for="ddlBudgetYear">Budget Year</label>
                            <select class="form-control" id="ddlBudgetYear">
                              <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                            </select>
                          </div>

                          <div class="col-sm-6" name="JournalBudgetType">
                            <div class="form-group">
                              <label for="txtBudgetType">Budget Type<em>*</em></label>
                              <input type="text" class="form-control" id="txtBudgetType" autocomplete="off">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6" name="JournalArticleBudget">
                            <div class="form-group">
                              <label for="txtArticleBudget ">Article Budget</label>
                              <input type="number" class="form-control" min="0" id="txtArticleBudget" />
                            </div>
                          </div>
                          <div class="col-sm-6" name="JournalArticlepagecount">
                            <div class="form-group">
                              <label for="txtArticlepagecount">Projected Average Page Count</label>
                              <input type="number" class="form-control" min="0" id="txtArticlepagecount" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6" name="JournalPerIssueTarget">
                            <div class="form-group">
                              <label for="txtPerIssueTarget">Per Issue Target</label>
                              <input type="number" class="form-control" min="0" id="txtPerIssueTarget" />
                            </div>
                          </div>
                          <div class="col-sm-6" name="JournalProjectedtotalpagecount">
                            <div class="form-group">
                              <label for="txtProjectedtotalpagecount">Non-Research Projected total page Count</label>
                              <input type="number" class="form-control" min="0" id="txtProjectedtotalpagecount" />
                            </div>
                          </div>
                          <div class="col-sm-12" name="JournalVolumePages">
                            <div class="form-group">
                              <label for="txtVolumePages">Volume Pages</label>
                              <input type="number" class="form-control" min="0" id="txtVolumePages" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideBudget()">Close</button>
                        <button type="submit" (click)="addUpdateBudget()" class="btn btn-outline-success waves-effect waves-light">{{BudgetModalButton}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--popup body end-->
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
            <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF" (click)="saveJournalInfo()">{{popUpButtonText}}</button>
          </div>
          <!--popup Loader-->
          <div id="LoadingImageReopen">
            <img src="assets/Images/loader.gif" style="font-size:100px" class="imgLoadimg" alt="Loading..." />
          </div>
        </div>

        <!-- excel Popup -->
        <div class="modal" id="ExcelPopupBody" [style.display]="showExcelPopupBody ? 'block' : 'none'">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header" id="modal-headerid">
                <h4 class="modal-title">Budget File Info</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hideExcelpopup()">&times;</button>
              </div>
              <button type="button" id="btnvalidationerror" (click)="addUpdateImportExcel()" style="display:none">Excel</button>
              <!--<button type="button" id="fileupload"  style="display:none">Excel</button>-->
              <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div class="col-6">
                      <div id="SupportingFiles">
                        <label for="Txt_SupportingFiles">Choose File</label><br />
                        <input id="doc_file" type="file" class="form-control" (change)="onImportSelected($event)"><br />
                      </div>
                    </div>
                    <div class="col-2" style="margin-top:1.6em;" id="btnUpload">
                      <button type="submit" (click)="addUpdateExcel()" class="btn btn-outline-success waves-effect waves-light">
                        <i class="fa fa-upload"></i>&nbsp;{{hideExcelModalButton}}
                      </button>
                    </div>
                    <div class="col-4" id="dtn_downloadSupportingFiles" style="margin-top:1.6em;">
                      <button type="button" class="btn btn-outline-primary waves-effect waves-light" id="DownloadCorrectFile" (click)="DownloadSupportFiles()"><i class="fa fa-download">&nbsp;</i><b>Download Sample File</b></button>
                    </div>
                  </div>
                  <label>Upload file should be same as download<span style="color: darkgreen;"> Excel</span> sample file with sheet name <span style="color: DodgerBlue;">AnnualBudget</span></label>
                </div>
              </div>
              <div class="modal-body" style="display:none" id="tblErrorValidation">
                <div class="col-md-12">
                  <div class="form-group tblRightsList fixTableHeadbudget">
                    <table id="tblErrorValidationList" class="table" style="overflow-y: scroll !important;">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Content</th>
                          <th>Status</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-footer" style="display:flex !important;">
                <!--<div id="errormessageLabel" style="display:none; float:left !important;">
                  <label>Please review the file you uploaded, make any necessary corrections, and reupload it.</label>
                </div>-->
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideExcelpopup()">Close</button>
              </div>
            </div>
          </div>
        </div>
        <!--Excel Validation Popup end -->
      </div>
    </div>
  </div>
</div>
